import { render, staticRenderFns } from "./RegisterDesktopSelect.vue?vue&type=template&id=c7839ab6&"
import script from "./RegisterDesktopSelect.vue?vue&type=script&lang=js&"
export * from "./RegisterDesktopSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports